import DropdownButton from 'components/Buttons/DropdownButton';
import SearchInput from 'components/Input/SearchInput';
import { diagnosisListPageText } from 'constants/diagnosisListPageConstants';
import styled from 'styled-components';
import { ResetIconWrapper } from 'styles/Input/inputStyle';
import RefreshIcon from 'assets/Icons/Common/RefreshIcon';
import { commonText } from 'constants/commonConstants';
import { AdminManageHospitalPageFilterProps } from 'models/DCKAdmin/AdminManageHospitalPageTypes';
import { ChildrenType } from 'models/Common/commonTypes';

interface AdminManageHospitalPageFilterPropsWithChildren extends AdminManageHospitalPageFilterProps, ChildrenType {}

const AdminManageHospitalPageFilter = ({ diagnosisNumber, onChange, searchValue, handleSearchFilter, children }: AdminManageHospitalPageFilterPropsWithChildren) => {
    return (
        <FilterContainer>
            <LeftSection>
                {(diagnosisNumber || 0) + diagnosisListPageText.countDiagnosis}
            </LeftSection>
            <RightSection>
                <FilterButtonWrapper>
                    <DropdownButton>{commonText.hospitalName}</DropdownButton>
                    <SearchInputWrapper>
                        <SearchInput onChange={onChange} searchValue={searchValue} handleSearchFilter={handleSearchFilter} />
                    </SearchInputWrapper>
                    <ResetIconWrapper onClick={() => window.location.reload()}>
                        <RefreshIcon />
                    </ResetIconWrapper>
                </FilterButtonWrapper>
                {children}
            </RightSection>
        </FilterContainer>
    );
};

export default AdminManageHospitalPageFilter;

const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const LeftSection = styled.div`
    display: flex;
    align-items: center;
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const FilterButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
`;

const SearchInputWrapper = styled.div`
    position: relative;
    width: 220px;
    height: 40px;
    border-radius: 4px;
`;
